import { FC } from "react";
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Modal } from 'antd';
import { useHistory } from "react-router";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  memberCode: string|undefined;
  campusCode: string|undefined;
}

const CompleteRetireModal: FC<IProps> = ({
  visible, setVisible, memberCode, campusCode
}) => {
  const { t } = useTranslation();
  const history = useHistory();

  const onClose = () => {
    setVisible(false);
    history.push('/payment/retire');
  }
  
  return (
    <Modal
      title={t('payment.retire.button2')}
      visible={visible}
      onCancel={onClose}
      footer={[
        <div className='comm-btn__area justify-content-center'>
          <AntButton
            key="primary"
            className='btn-basic pink'
            onClick={() => {
              setVisible(false);
              history.push(`/student/student?memberCode=${memberCode}&campusCode=${campusCode}&tabIndex=4`)
            }}
          >
            {t('payment.retire.button4')}
          </AntButton>
          <AntButton
            key="primary"
            className='btn-basic pink'
            onClick={() => {
              setVisible(false);
              history.push(`/student/student?memberCode=${memberCode}&campusCode=${campusCode}&tabIndex=3`)
            }}
          >
            {t('payment.retire.button5')}
          </AntButton>
          <AntButton
            key="cancel"
            className='btn-basic gray'
            onClick={onClose}
          >
            {t('common.button.close')}
          </AntButton>
        </div>
      ]}
    >
      {t('payment.retire.text3')}
    </Modal>
  );
}

export default CompleteRetireModal;
